const shoppingCartList = []

export default {
  shoppingCartList
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/shoppting-cart/store/state.js